module.exports = __webpack_public_path__ + "static/media/baby-cry.6c3fe30c.svg";